/* eslint-disable */
import React from 'react'
import {Link} from 'react-router-dom'
import http from '../Interceptor/Interseptor'
import {message} from 'antd'
import Select from 'react-select'

class CreateCartStation extends React.Component {
  constructor(props) {
    super(props)
    this.state = {}
  }

  submit(e) {
    e.preventDefault()
  }

  createCartStation() {
    let title = document.getElementById('title').value.trim()
    if (title === '') {
      message.error('عنوان را وارد کنید')
    } else {
      let data = {
        title
      }
      http.post(`cartStation/create`, data, {}).then((res) => {
        if (res.data.error === null) {
          message.success('جایگاه با موفقیت اضافه شد')
          setTimeout(() => {
            window.location.assign('/cartStation/report')
          }, 3000)
        }
      })
    }
  }

  render() {
    return (
      <div className="rtl printA4Page">
        <div className="wrapperIframe">
          <ul className="breadcrumb">
            <li>
              <Link to={'/search'}>به روزرسان</Link>
            </li>
            <li>توزیع</li>
            <li>جایگاه</li>
            <li>افزودن جایگاه</li>
          </ul>
          <form className="verticalForm" onSubmit={this.submit.bind(this)}>
            <div className="headerVertical">
              <p>افزودن جایگاه</p>
            </div>
            <div className="formComponent selectComponent">
              <label>عنوان :‌</label>
              <input type="text" id="title" className="form-control" />
            </div>

            <div className="formComponent selectComponent">
              <button className="btn btn-info btn-block jasperBtn" onClick={this.createCartStation.bind(this)}>
                افزودن جایگاه
              </button>
              <p className="errorText" id="errorText" />
            </div>
          </form>
        </div>
      </div>
    )
  }
}
export default CreateCartStation
